import { app } from '../../../../app';
import { Controller } from './sharing-settings.controller';

app.component('companySharingCenterSettings', {
    bindings: {
    settingsDetails:'<'
    },
    templateUrl: require('./sharing-settings.html'),
    controller: Controller,
});




// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/sharing-settings/sharing-settings.component.js